<div class="h-100 eng-drawing">
  <div class="row w-100 headerWrapper mx-0" [style.height.px]="headerHeight">
    @if (application$ | async; as application) {
      <div class="navbar fixed-top container-fluid pl-0" #fixedHeader>
        <dnv-mood-canvas class="dnv-mood-canvas"></dnv-mood-canvas>
        <div class="row w-100 mx-0 d-flex">
          <div class="pl-0">
            <h1 class="navbar-brand" title="GeoTools">Geotools</h1>
          </div>
        </div>
      </div>
    }

  </div>
  <div class="row w-100 mx-0">
    <ul class="nav nav-tabs mt-1" id="reportTabs" role="tablist">
      <li class="nav-item list-margin">
        <a class="nav-link active" id="cads-tab" data-bs-toggle="tab" href="#cad" role="tab" aria-controls="cad"
        aria-selected="true" title="Details">CAD Applications</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" id="outstanding-tab" data-bs-toggle="tab" href="#outstanding" role="tab"
        aria-controls="outstanding" aria-selected="true">Outstanding Drawings</a>
      </li>

    </ul>

    <div class="tab-content" [style.height.px]="panelHeight">
      <div class="tab-pane fade show active" id="cad" role="tabpanel" aria-labelledby="cad-tab">
        <div class="grid-wrapper">
          <button type="button" class="clear-search" (click)="onClearCadSearch()" [class.d-none]="!showGridClear">
            <i class="far fa-times-circle clear-search-icon"></i>
          </button>
          <div class="row w-100 mx-0 h-100 overflow-auto grid" [class.mt-0]="!showGridClear">
            <ejs-grid id="Grid" #grid [dataSource]="cad" [allowPaging]="true" [pageSettings]="pageSettings"
              [allowSorting]="true" [allowFiltering]="true" [filterSettings]="filterOption"
              [editSettings]="editSettings" (dataBound)='dataBound()' allowTextWrap="true"
              [textWrapSettings]="{ wrapMode: 'Both' }" (load)="loadCAD()" [toolbar]="['Search', 'ExcelExport']"
              [allowExcelExport]="true" (toolbarClick)="toolbarClick($event)" [allowResizing]="true"
              (created)="onCADCreated()" (actionBegin)="onActionBeginCAD($event)" class="px-0">
              <e-columns>
                <e-column field='drawing' headerText='Drawing'></e-column>
                <e-column field='projectStartDate' headerText='Started' type="date" [format]="dateFormat"
                [filter]="filter"></e-column>
                <e-column field='designer' headerText='Designer'></e-column>
                <e-column field='deliveryLead' headerText='DNV Section (Delivery Lead)' editType='dropdownedit'
                [edit]="deliveryLeadParams"></e-column>
                <e-column field='projectName' headerText='Name'></e-column>
                <e-column field='projectDescription' headerText='Description' clipMode="EllipsisWithTooltip"></e-column>
                <e-column field='projectFrom' headerText='From'></e-column>
                <e-column field='projectTo' headerText='To'></e-column>
                <e-column field='projectStatus' headerText='Status' editType='dropdownedit'
                [edit]="cadParams"></e-column>
                <e-column field='capProjId' headerText='Cap Proj ID' clipMode="EllipsisWithTooltip"></e-column>
                <e-column field='comments' headerText='Comments'></e-column>
                <e-column headerText='Edit' [commands]='commands'></e-column>
              </e-columns>
            </ejs-grid>

          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="outstanding" role="tabpanel" aria-labelledby="outstanding-tab">
        <div class="grid-wrapper">
          <button type="button" class="clear-search" (click)="onClearOutSearch()" [class.d-none]="!showGrid2Clear">
            <i class="far fa-times-circle clear-search-icon"></i>
          </button>
          <div class="row w-100 mx-0 h-100 overflow-auto grid" [class.mt-0]="!showGrid2Clear">
            <ejs-grid #grid2 id="Grid2" [dataSource]="outstandingED" [allowPaging]="true" [pageSettings]="pageSettings"
              [allowSorting]="true" [allowFiltering]="true" [editSettings]='editSettings' (dataBound)='dataBound()'
              [allowTextWrap]="true" [filterSettings]="filterOption" (load)="loadOutstanding()"
              [toolbar]="['Search', 'ExcelExport']" (toolbarClick)="toolbarClick($event)" [allowExcelExport]="true"
              (actionBegin)="onActionBeginOutstanding($event)" [allowResizing]="true" (created)="onOutCreated()">
              <e-columns>
                <e-column field='adminDrawing' headerText='Drawing'></e-column>
                <e-column field='projectStartDate' headerText='Started' type="date" [format]="dateFormat"
                [filter]="filter"></e-column>
                <e-column field='designer' headerText='Designer'></e-column>
                <e-column field='admin_MustHaveAsbuilt' headerText='MustHaveAsBuilt'></e-column>
                <e-column field='admin_ReceivedCON' headerText='ReceivedCON'></e-column>
                <e-column field='admin_ReceivedASB' headerText='ReceivedASB'></e-column>
                <e-column field='status' headerText='Project Status' editType='dropdownedit'
                [edit]="edParams"></e-column>
                <e-column field='comments' headerText='Comments'></e-column>
                <e-column headerText='Edit' [commands]='commands'></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>

    </div>

  </div>